module.exports = __webpack_public_path__ + "static/media/google_fr.7bf5d76e.png";